export default __webpack_public_path__ + "static/media/chat-map-gray.879a6282.png";